var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVolumeX(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 3.43958V20.5605L5.73691 15.75H1.25V8.25004H5.73691L11.75 3.43958ZM10.25 6.56051L6.26309 9.75004H2.75V14.25H6.26309L10.25 17.4396V6.56051Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0608 8.99999L17.0001 16.0607L15.9395 15L23.0001 7.93933L24.0608 8.99999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0001 7.93933L24.0608 15L23.0001 16.0607L15.9395 8.99999L17.0001 7.93933Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeX);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Zz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjc1IDMuNDM5NThWMjAuNTYwNUw1LjczNjkxIDE1Ljc1SDEuMjVWOC4yNTAwNEg1LjczNjkxTDExLjc1IDMuNDM5NThaTTEwLjI1IDYuNTYwNTFMNi4yNjMwOSA5Ljc1MDA0SDIuNzVWMTQuMjVINi4yNjMwOUwxMC4yNSAxNy40Mzk2VjYuNTYwNTFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI0LjA2MDggOC45OTk5OUwxNy4wMDAxIDE2LjA2MDdMMTUuOTM5NSAxNUwyMy4wMDAxIDcuOTM5MzNMMjQuMDYwOCA4Ljk5OTk5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy4wMDAxIDcuOTM5MzNMMjQuMDYwOCAxNUwyMy4wMDAxIDE2LjA2MDdMMTUuOTM5NSA4Ljk5OTk5TDE3LjAwMDEgNy45MzkzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvZz48L3N2Zz4=";
export { ForwardRef as ReactComponent };